const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "TaskQueueType",
                "tableName": "IDCUSTOMER",
                "label": "Filter",
                "type": "select",
                "showClearButton": true,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ArchiveDt",
                "tableName": "ABTaskQueueLive",
                "label": "Archive Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "TaskType",
                "tableName": "ABTaskQueueLive",
                "label": "Task Type",
                "type": "select",
                "showClearButton": true,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "State",
                "tableName": "ABTaskQueueLive",
                "label": "State",
                "type": "select",
                "showClearButton": true,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "ProcessingStartDt",
                "tableName": "ABTaskQueueLive",
                "label": "Processing Start Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "ABTaskQueueLive",
                "label": "Created On",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "ProcessingEndDt",
                "tableName": "ABTaskQueueLive",
                "label": "Processing End Date",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "OwnerId",
                "tableName": "ABTaskQueueLive",
                "label": "Owner Id",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Reference",
                "tableName": "ABTaskQueueLive",
                "label": "Reference",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "SourceTableName",
                "tableName": "ABTaskQueueLive",
                "label": "Source Table Name",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RSourceId",
                "tableName": "ABTaskQueueLive",
                "label": "Source Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "DataEventType",
                "tableName": "ABTaskQueueLive",
                "label": "Data Event Type",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "RAbTaskProcessor",
                "tableName": "ABTaskQueueLive",
                "label": "Processor Id",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


            {
                "name": "ProcessingResultCode",
                "tableName": "ABTaskQueueLive",
                "label": "Processing Code",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },
            {
                "name": "ProcessingResultInfo",
                "tableName": "ABTaskQueueLive",
                "label": "Processing Info",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            },


        ]
    }
]
export { SearchLayout };